import {api,req} from "../api.ts";
import {h} from "../dom.ts";
import {t} from "../i18n/index.ts";
import {readPlayer} from "../play/client.ts";
import {rememberReturn} from "../returnContext.ts";
import {topNav} from "../ui/topnav.ts";
import {emailSignIn} from "./emailSignIn.ts";

/** Opening a private URL is read-only until the person explicitly signs in. */
export function resourceRecovery(path: string): HTMLElement {
  rememberReturn(path);
  const root=h(`<main class="card resource-recovery"><h1>${t("return.title")}</h1><p>${t("return.help")}</p><div data-recovery></div><p class="msg" role="status"></p></main>`);
  root.prepend(topNav(null));
  const box=root.querySelector<HTMLElement>("[data-recovery]")!;
  const retry=document.createElement("button");retry.className="btn";retry.textContent=t("common.retry");retry.onclick=()=>location.reload();
  void Promise.all([readPlayer(),api.getConfig()]).then(([player,config])=>{
    if (player?.kind==="account") {
      box.append(h(`<p>${t("return.account")}</p>`));
      const change=document.createElement("button");change.className="btn";change.textContent=t("return.switch");
      change.onclick=async()=>{ change.disabled=true; try { await req("POST","/api/play/logout"); location.reload(); } catch { root.querySelector(".msg")!.textContent=t("settings.signOutFailed");change.disabled=false; } };
      box.append(change);
    } else if (config.email_signin_enabled) box.append(emailSignIn(config.registration_mode==="public"));
    else box.append(h(`<p>${t("library.emailDisabled")}</p>`));
    box.append(retry);
  }).catch(()=>{root.querySelector(".msg")!.textContent=t("return.failed");box.append(retry);});
  return root;
}
